'use client'

import { useThemeStore } from '@/components/findex-connect/store/ThemeStore'

export const BackgroundSwitcher = ({ children }: { children: React.ReactNode }) => {
  const backgroundColor = useThemeStore((state) => state.backgroundColor)

  return (
    <div
      className="BACKGROUND-SWITCHER relative z-10 h-full w-full transition-all duration-700 ease-in-out"
      style={{ backgroundColor: backgroundColor || 'white' }}
    >
      <div className="BACKGROUND-SWITCHER-CHILDREN">{children}</div>
    </div>
  )
}
